(function () {
  function normalizeValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isPlaceholder(value) {
    const v = normalizeValue(value);
    return !v || v === 'choose options' || v === 'choose option';
  }

  function safeParseJson(node, fallback) {
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function getSelectByOptionName(container, optionName) {
    try {
      return container.querySelector(`select[name="${CSS.escape(optionName)}"]`);
    } catch (error) {
      const selects = container.querySelectorAll('select[name]');
      for (const select of selects) {
        if (select.name === optionName) return select;
      }
      return null;
    }
  }

  function getCurrentSelections(container, productOptions) {
    const selections = {};

    productOptions.forEach((optionName) => {
      const select = getSelectByOptionName(container, optionName);

      if (!select) {
        selections[optionName] = null;
        return;
      }

      selections[optionName] = isPlaceholder(select.value) ? null : select.value;
    });

    return selections;
  }

  function updateAtcState(container, productOptions) {
    const buttons = container.querySelectorAll('.add_to_cart_button');
    if (!buttons.length) return;

    const selections = getCurrentSelections(container, productOptions);
    const hasUnselectedOption = productOptions.some((optionName) => !selections[optionName]);

    buttons.forEach((button) => {
      if (hasUnselectedOption) {
        button.setAttribute('disabled', 'disabled');
      } else {
        button.removeAttribute('disabled');
      }
    });
  }

  function findBestMatchingVariant(productOptions, productVariants, selections) {
    const matches = productVariants.filter((variant) => {
      return productOptions.every((optionName, index) => {
        const selectedValue = selections[optionName];
        if (!selectedValue) return true;

        return normalizeValue(variant.options?.[index]) === normalizeValue(selectedValue);
      });
    });

    if (!matches.length) return null;
    return matches.find((variant) => variant.featured_media_id) || matches[0];
  }

  function activateMediaById(container, mediaId) {
    if (!mediaId) return;

    const mediaIdStr = String(mediaId);

    const thumb =
      container.querySelector(`[data-target="${mediaIdStr}"]`) ||
      container.querySelector(`[data-target*="${mediaIdStr}"]`) ||
      container.querySelector(`[data-thumbnail-id="${mediaIdStr}"]`) ||
      container.querySelector(`[data-thumbnail-id*="${mediaIdStr}"]`) ||
      container.querySelector(`[data-media-id="${mediaIdStr}"] button`) ||
      container.querySelector(`[data-media-id*="${mediaIdStr}"] button`);

    if (thumb) {
      thumb.click();
      return;
    }

    const mediaItem =
      container.querySelector(`[data-media-id="${mediaIdStr}"]`) ||
      container.querySelector(`[data-media-id*="${mediaIdStr}"]`);

    if (!mediaItem) return;

    const allMedia = container.querySelectorAll('[data-media-id], .product__media-item, .swiper-slide');

    allMedia.forEach((item) => {
      item.classList.remove('is-active', 'active', 'swiper-slide-active');
      item.setAttribute('aria-hidden', 'true');
    });

    mediaItem.classList.add('is-active', 'active');
    mediaItem.removeAttribute('aria-hidden');
  }

  function updateMediaFromSelections(container, productOptions, productVariants) {
    const selections = getCurrentSelections(container, productOptions);
    const matchedVariant = findBestMatchingVariant(productOptions, productVariants, selections);

    if (!matchedVariant || !matchedVariant.featured_media_id) return;
    activateMediaById(container, matchedVariant.featured_media_id);
  }

  function initProductOptionBehavior(container) {
    if (!container || container.dataset.productOptionBehaviorInitialized === 'true') return;
    container.dataset.productOptionBehaviorInitialized = 'true';

    const enableMediaSync = container.dataset.enableMediaSync !== 'false';
    const enableAtcGuard =
      container.dataset.enableAtcGuard !== 'false' &&
      !container.querySelector('[data-amc-diy-variant-gate-root]');

    const productOptions = safeParseJson(
      container.querySelector('[data-product-options-json]'),
      []
    );

    const productVariants = safeParseJson(
      container.querySelector('[data-product-variants-json]'),
      []
    );

    if (!productOptions.length) return;

    const handleUpdate = function () {
      if (enableAtcGuard) {
        updateAtcState(container, productOptions);
      }

      if (enableMediaSync && productVariants.length) {
        updateMediaFromSelections(container, productOptions, productVariants);
      }
    };

    container.addEventListener('change', function (event) {
      const target = event.target;
      if (!target || target.tagName !== 'SELECT') return;
      handleUpdate();
    });

    handleUpdate();
  }

  function initAllProductOptionBehaviors(scope) {
    (scope || document)
      .querySelectorAll('[data-product-option-behavior]')
      .forEach(initProductOptionBehavior);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllProductOptionBehaviors(document);
    });
  } else {
    initAllProductOptionBehaviors(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllProductOptionBehaviors(event.target || document);
  });
})();